import { BuildFontString } from "../utils/BuildFontString";
import {
  enumAutoTextType,
  enumBoxSubTypes,
  enumCellContentType,
  enumCellRefType,
  enumFieldDisplayMode,
  enumFieldType,
  enumFillMode,
  enumHierarchyTypes,
  enumHyperLinkType,
  enumImageNameIndex,
  enumObjClassNames,
  enumPicMask,
  enumPictureType,
  enumScalingMethod,
  enumUpdateProperty,
  enumWrapTextMode,
  kDefPicFrameH,
  kDefPicFrameW,
  kMissingPic,
  kPickerColors
} from "../constants";
import { sanitizeBlockedValue } from "../utils/FormatFieldValue";
import { GetFieldLink } from "../utils/GetFieldLink";
import { GetPicSource } from "../utils/GetPicSource";
import { IsRefBox } from "../utils/IsRefBox";
import { LDecimalPlaces } from "../utils/LDecimalPlaces";
import { MapVAlign } from "../utils/MapVAlign";
import { QPicDesc } from "./QPicDesc";
import { QPoint } from "./QPoint";
import { QTextFormat } from "./QTextFormat";
import { QXMLObject } from "./QXMLObject";
import { Globals } from "./Globals";
import { QFieldDisplayInfo } from "../utils/QFieldDisplayInfo";
import { FormatFieldValue } from "../utils/FormatFieldValue";
import { EscRegExpression } from "../utils/EscRegExpression";
import { StringToBool } from "../utils/StringToBool";
import { formatArray } from "../utils/formatArray";
import { QBoxCellObj } from "./QBoxCellObj";

export class QBoxCellDesc extends QXMLObject {
  constructor() {
    // Location
    super();
    this.fCol = 0; // Column
    this.fRow = 0; // Row
    this.fColSpan = 1; // Span the number of column
    this.fRowSpan = 1; // Span the number of row

    // Alignment
    this.fAlignment = "left"; // Left, center, right
    this.fVAlignment = "m"; // Top, middle, bottom
    this.fExpandRow = false;

    this.fWrapText = enumWrapTextMode.nowrap;

    //this.fDoCellFill = true;							// Fill with a color
    this.fCellFillColor = "#FFFFFF"; // Fill with this color
    this.fCellFillColor2 = "#FFFFFF";
    this.fCellFillMode = enumFillMode.noFill;

    this.fFieldDisplayMode = enumFieldDisplayMode.FieldOnly;

    this.fField = null;
    this.fFieldName = null;
    this.fFieldID = null;
    this.fFieldClassName = null;
    this.fRefType = enumCellRefType.topbox;

    this.fCellContentType = enumCellContentType.Blank;
    this.fCellObjectSubtype = null;
    this.fFreeText = null;
    this.fAutoTextType = enumAutoTextType.none;

    this.fSPictureDirectory = null;
    this.fSPictureFile = null;
    this.fSPictureWidth = null;
    this.fSPictureHeight = null;
    this.fScalingMethod = enumScalingMethod.lockaspect;

    this.fIconIndex = null;

    this.fPictureFrameWidth = null;
    this.fPictureFrameHeight = null;
    this.fPicMask = enumPicMask.nomask;

    this.fTextFormat = null;

    this.fGutterCell = false;

    this.fParentLayout = null;

    // Calculated
    this.fLocationX = 0;
    this.fLocationY = 0;
    this.fCellWidth = 0;
    this.fCellHeight = null;
    this.fNumRowsInCell = 1;
    this.fNumContentRows = 1;

    // Borders
    //	this.fBorderSegmentList = null;
    //	this.SetXMLElementName("boxcell");

    this.fMeasuredHeight = null;
    this.fBreakChars = null;
    //    this.fEscBreakChars = null;

    //	this.fContentHeight = null;
    this.fDeferredPicLoad = false;

    this.fMergeX = 0;
    this.fMergeY = 0;
    this.fHidden = false;
    this.fPieSections = [];
    this.fMaxCellRows = 10;
    this.fOverrides = null;
  }

  InitBoxCell(x, y, parentLayout) {
    this.fParentLayout = parentLayout;

    this.fCol = x;
    this.fRow = y;
    this.fTextFormat = new QTextFormat();
    this.fTextFormat.InitTextFormat();
    this.fOverrides = {};
    //this.AddBorderSegments();
  }

  HasOverrides() {
    var hasCellOverrides = this.fOverrides && Object.keys(this.fOverrides).length > 0;
    if (hasCellOverrides) {
      return true;
    }

    return this.GetTextFormat().HasOverrides();
  }

  GetXMLElementName() {
    return "boxcell";
  }

  Journal() {
    this.fParentLayout.Journal();
  }

  CopyCellFormat(copyFrom) {
    this.fAlignment = copyFrom.fAlignment;
    this.fVAlignment = copyFrom.fVAlignment;
    this.fExpandRow = copyFrom.fExpandRow;
    this.fWrapText = copyFrom.fWrapText;
    this.fCellFillColor = copyFrom.fCellFillColor;
    this.fCellFillColor2 = copyFrom.fCellFillColor2;
    this.fCellFillMode = copyFrom.fCellFillMode;

    this.fOverrides = copyFrom.fOverrides;
    this.fFieldDisplayMode = copyFrom.fFieldDisplayMode;

    this.fMergeX = 0; //copyFrom.fMergeX;
    this.fMergeY = 0; //copyFrom.fMergeY;
    this.fHidden = false; //copyFrom.fHidden;

    this.fTextFormat = copyFrom.fTextFormat.Clone();
  }

  SetParentLayout(parentLayout) {
    this.fParentLayout = parentLayout;
  }

  Clone() {
    var c = new QBoxCellDesc();

    c.fCol = this.fCol;
    c.fRow = this.fRow;
    c.fColSpan = this.fColSpan;
    c.fRowSpan = this.fRowSpan;

    c.fAlignment = this.fAlignment;
    c.fVAlignment = this.fVAlignment;
    c.fExpandRow = this.fExpandRow;
    c.fWrapText = this.fWrapText;

    // Fill with a color
    c.fCellFillColor = this.fCellFillColor;
    c.fCellFillColor2 = this.fCellFillColor2;

    c.fCellFillMode = this.fCellFillMode;

    c.fFieldDisplayMode = this.fFieldDisplayMode;

    c.fField = this.fField;
    c.fCellContentType = this.fCellContentType;
    c.fCellObjectSubtype = this.fCellObjectSubtype;
    c.fFreeText = this.fFreeText;
    c.fAutoTextType = this.fAutoTextType;

    c.fSPictureDirectory = this.fSPictureDirectory;
    c.fSPictureFile = this.fSPictureFile;
    c.fSPictureWidth = this.fSPictureWidth;
    c.fSPictureHeight = this.fSPictureHeight;
    c.fScalingMethod = this.fScalingMethod;

    c.fPictureFrameWidth = this.fPictureFrameWidth;
    c.fPictureFrameHeight = this.fPictureFrameHeight;
    c.fPicMask = this.fPicMask;

    c.fTextFormat = this.fTextFormat.Clone();

    c.fGutterCell = this.fGutterCell;
    c.fLocationX = this.fLocationX;
    c.fLocationY = this.fLocationY;
    c.fCellWidth = this.fCellWidth;
    c.fCellHeight = this.fCellHeight;

    c.fFieldName = this.fFieldName;
    c.fFieldID = this.fFieldID;
    c.fFieldClassName = this.fFieldClassName;
    c.fRefType = this.fRefType;

    c.fMergeX = this.fMergeX;
    c.fMergeY = this.fMergeY;
    c.fHidden = this.fHidden;

    c.fOverrides = { ...(this.fOverrides || {}) };

    c.fIconIndex = this.fIconIndex;

    /*
	c.fBorderSegmentList = null;
	if (this.fBorderSegmentList)
	{
		c.fBorderSegmentList = new Array();
		var n = this.fBorderSegmentList.length;
		for (var i=0; i<n; i++)
			c.fBorderSegmentList.push(this.fBorderSegmentList[i].Clone(this));
	}
	*/

    return c;
  }

  //var gPriorBorderSegment = null;
  OutputSubElements(stream) {
    var theField = this.fField;

    var fieldName = null;
    var className = null;
    var fieldID = null;
    var isBoxStyle = this.fParentLayout.IsBoxStyle();
    if (theField) {
      fieldName = theField.GetFieldName();
      fieldID = theField.GetFieldID();
      className = theField.GetFieldClassName();
    } else if (isBoxStyle) {
      fieldName = this.GetFieldSaveName();
      fieldID = this.GetFieldSaveID();
      className = this.GetFieldSaveClassName();
    }

    if (fieldName != null) {
      this.OutputSimpleElement("fieldname", fieldName, stream);
      this.OutputSimpleElement("fieldid", fieldID, stream);
      this.OutputSimpleElement("fieldclassname", className, stream);

      if (this.fRefType != enumCellRefType.topbox)
        this.OutputSimpleElement("reftype", this.fRefType, stream);
    }

    this.OutputElementPair("cellcolrow", this.fCol, this.fRow, stream);
    var match = this.CompareCells(Globals._priorCellFormat, true, false, false, isBoxStyle);
    if (match != "Match") {
      this.OutputElementTriple(
        "alignment",
        this.fAlignment,
        this.fVAlignment,
        this.fWrapText,
        stream
      );
      this.OutputElementPair("cellcolor", this.fCellFillColor, this.fCellFillMode, stream);

      var cc2 = this.fCellFillColor2;
      if (cc2 != null && cc2 != "#FFFFFF")
        this.OutputSimpleElement("cellcolor2", this.fCellFillColor2, stream);

      this.OutputElementPair(
        "celldisplaycontent",
        this.fFieldDisplayMode,
        this.fCellContentType,
        stream
      );
      this.OutputSimpleElement("cellsubtype", this.fCellObjectSubtype, stream);
      if (this.fExpandRow) this.OutputSimpleElement("expandrow", this.fExpandRow, stream);
      if (this.fPictureFrameWidth)
        this.OutputElementPair(
          "picframe",
          this.fPictureFrameWidth,
          this.fPictureFrameHeight,
          stream
        );
      this.OutputSimpleElement("picmask", this.fPicMask, stream);
    }
    Globals._priorCellFormat = this;

    if (this.fFreeText != null) this.OutputSimpleElement("freeText", this.fFreeText, stream);
    if (this.fAutoTextType != null && this.fAutoTextType != enumAutoTextType.none)
      this.OutputSimpleElement("autoText", this.fAutoTextType, stream);

    if (this.fSPictureDirectory != null && this.fSPictureFile != null) {
      this.OutputElementQuad(
        "picture",
        this.fSPictureDirectory,
        this.fSPictureFile,
        this.fSPictureWidth,
        this.fSPictureHeight,
        stream
      );
      if (this.fScalingMethod != enumScalingMethod.lockaspect)
        this.OutputSimpleElement("pscale", this.fScalingMethod, stream);
    }
    this.OutputElementQuad(
      "locationrect",
      this.fLocationX,
      this.fLocationY,
      this.fCellWidth,
      this.fCellHeight,
      stream
    );

    var isMerged = this.IsMergedCell();
    if (isMerged) this.OutputElementPair("merge", this.fMergeX, this.fMergeY, stream);

    var isHidden = this.IsHidden();
    if (isHidden) this.OutputSimpleElement("hide", this.fHidden, stream);
  }

  SetGutterState(numCols, numRows) {
    var gutterCell = false;
    numCols += 2;
    numRows += 2;

    var rowIndex = this.fRow;
    var colIndex = this.fCol;

    if (rowIndex == 0 || rowIndex == numRows - 1) gutterCell = true;
    else if (colIndex == 0 || colIndex == numCols - 1) gutterCell = true;

    this.fGutterCell = gutterCell;
  }

  LoadFromJSON(data) {
    if (data["field"]) {
      var fieldData = data["field"];
      var className = fieldData["className"];
      var ID = fieldData["ID"];
      var name = fieldData["name"];
      this.SetFieldInfo(name, ID, className);
      var freeText = fieldData["freetext"];
      if (freeText) this.fFreeText = freeText;
      //TODO:
      this.fRefType = fieldData["reftype"];
      if (this.fRefType == null) this.fRefType = enumCellRefType.topbox;
    }
    this.fCol = data["col"];
    this.fRow = data["row"];

    if (data["alignment"]) {
      this.fAlignment = data["alignment"]["hAlign"];
      this.fVAlignment = MapVAlign(data["alignment"]["vAlign"]);
      var wrapT = data["alignment"]["wrap"];
      if (wrapT == "true") wrapT = enumWrapTextMode.unlimited;
      else if (wrapT == "false") wrapT = enumWrapTextMode.nowrap;
      else wrapT = parseInt(wrapT);

      this.fWrapText = wrapT;
    } else {
      this.fAlignment = Globals._priorCellFormat.fAlignment;
      this.fVAlignment = Globals._priorCellFormat.fVAlignment;
      this.fExpandRow = Globals._priorCellFormat.fExpandRow;
      this.fWrapText = Globals._priorCellFormat.fWrapText;
      this.fCellFillColor = Globals._priorCellFormat.fCellFillColor;
      this.fCellFillColor2 = Globals._priorCellFormat.fCellFillColor2;

      this.fCellFillMode = Globals._priorCellFormat.fCellFillMode;
      this.fFieldDisplayMode = Globals._priorCellFormat.fFieldDisplayMode;
      this.fCellContentType = Globals._priorCellFormat.fCellContentType;
      this.fCellObjectSubtype = Globals._priorCellFormat.fCellObjectSubtype;

      this.fPictureFrameWidth = Globals._priorCellFormat.fPictureFrameWidth;
      this.fPictureFrameHeight = Globals._priorCellFormat.fPictureFrameHeight;
      this.fPicMask = Globals._priorCellFormat.fPicMask;
    }

    var autoTextType = data["autoTextType"];
    this.fAutoTextType = autoTextType != null ? autoTextType : enumAutoTextType.none;

    this.fExpandRow = data["expandRow"] === true;

    if (data["color"]) {
      this.fCellFillColor = data["color"]["fill"];
      this.fCellFillMode = data["color"]["mode"];
      this.fCellFillColor2 = data["color"]["gradientFill"];
    }
    if (data["display"]) {
      this.fFieldDisplayMode = data["display"]["mode"];
      this.fCellContentType = data["display"]["contentType"];
    }
    if (data["picFrame"]) {
      this.fPictureFrameWidth = data["picFrame"]["width"];
      this.fPictureFrameHeight = data["picFrame"]["height"];
    }
    this.fCellObjectSubtype = data["subType"];
    this.fPicMask = data["picMask"] != null ? data["picMask"] : enumPicMask.nomask;

    if (data["picture"]) {
      this.fSPictureDirectory = data["picture"]["directory"];
      this.fSPictureFile = data["picture"]["file"];
      this.fSPictureWidth = data["picture"]["width"];
      this.fSPictureHeight = data["picture"]["height"];
    }

    this.fScalingMethod = enumScalingMethod.lockaspect;
    if (data["pscale"] != null) {
      this.fScalingMethod = data["pscale"];
    }

    if (data["location"]) {
      this.fLocationX = data["location"]["xPos"];
      this.fLocationY = data["location"]["yPos"];
      this.fCellWidth = data["location"]["width"];
      this.fCellHeight = data["location"]["height"];
    }

    if (data["merge"]) {
      this.fMergeX = data["merge"]["xPos"];
      this.fMergeY = data["merge"]["yPos"];
    }

    var hf = data["hide"] ?? false;
    this.fHidden = hf;

    Globals._priorCellFormat = this;

    this.fTextFormat = new QTextFormat();
    this.fTextFormat.InitTextFormat();
    this.fTextFormat.LoadFromJSON(data["format"]);

    this.fIconIndex = data["iconIndex"] ?? null;
  }

  SaveToJSON() {
    var cell = {};
    var isBoxStyle = this.fParentLayout.IsBoxStyle();

    var field = {};
    if (this.fFreeText != null) field["freetext"] = this.fFreeText;

    if (this.fField || (isBoxStyle && this.fFieldID)) {
      field["name"] = this.fFieldName;
      field["ID"] = this.fFieldID;
      field["className"] = this.fFieldClassName;

      if (this.fRefType != enumCellRefType.topbox) field["reftype"] = this.fRefType;
    }
    if (Object.keys(field).length > 0) cell["field"] = field;

    cell["row"] = this.fRow;
    cell["col"] = this.fCol;

    var match = this.CompareCells(Globals._priorCellFormat, true, false, false, isBoxStyle);
    if (match != "Match") {
      var alignment = {};
      alignment["hAlign"] = this.fAlignment;
      alignment["vAlign"] = this.fVAlignment;
      alignment["wrap"] = this.fWrapText;
      cell["alignment"] = alignment;

      var color = {};
      color["fill"] = this.fCellFillColor;
      color["mode"] = this.fCellFillMode;
      color["gradientFill"] = this.fCellFillColor2;
      cell["color"] = color;

      var display = {};
      display["mode"] = this.fFieldDisplayMode;
      display["contentType"] = this.fCellContentType;
      cell["display"] = display;

      if (this.fCellObjectSubtype != null) cell["subType"] = this.fCellObjectSubtype;

      if (this.fExpandRow == true) cell["expandRow"] = true;

      if (this.fPictureFrameWidth) {
        var picFrame = {};
        picFrame["width"] = this.fPictureFrameWidth;
        picFrame["height"] = this.fPictureFrameHeight;
        cell["picFrame"] = picFrame;
      }

      if (this.fPicMask != null) cell["picMask"] = this.fPicMask;
    }
    Globals._priorCellFormat = this;

    if (this.fAutoTextType != null && this.fAutoTextType != enumAutoTextType.none)
      cell["autoTextType"] = this.fAutoTextType;

    if (this.fSPictureDirectory != null && this.fSPictureFile != null) {
      var staticPic = {};
      staticPic["directory"] = this.fSPictureDirectory;
      staticPic["file"] = this.fSPictureFile;
      staticPic["width"] = this.fSPictureWidth;
      staticPic["height"] = this.fSPictureHeight;
      if (this.fScalingMethod != enumScalingMethod.lockaspect) cell["pscale"] = this.fScalingMethod;
      cell["picture"] = staticPic;
    }

    var location = {};
    location["xPos"] = this.fLocationX;
    location["yPos"] = this.fLocationY;
    location["width"] = this.fCellWidth;
    location["height"] = this.fCellHeight;
    cell["location"] = location;

    var isMerged = this.IsMergedCell();
    if (isMerged) cell["merge"] = { xPos: this.fMergeX, yPos: this.fMergeY };

    var isHidden = this.IsHidden();
    if (isHidden) cell["hide"] = true;

    var match = this.fTextFormat.Compare(Globals._priorTextFormat);
    if (!match) {
      var format = {};
      format["font"] = this.fTextFormat.fFontName;
      format["size"] = this.fTextFormat.fFontSize;
      format["color"] = this.fTextFormat.fFontColor;

      format["bold"] = this.fTextFormat.fBold;
      format["italic"] = this.fTextFormat.fItalic;
      format["underline"] = this.fTextFormat.fUnderline;

      cell["format"] = format;

      Globals._priorTextFormat = this.fTextFormat;
    }

    cell["iconIndex"] = this.fIconIndex ?? null;

    return cell;
  }

  LoadSubElements(objTree) {
    var fieldName = objTree.GetValueForChild("fieldname", false);
    if (fieldName != "null" && fieldName != null) {
      var className = objTree.GetValueForChild("fieldclassname", false);
      var fieldID = objTree.GetValueForChild("fieldID", false);
      if (fieldID == null) fieldID = fieldName;
      this.SetFieldInfo(fieldName, fieldID, className);

      this.fRefType = objTree.GetValueForChild("reftype", true);
      if (this.fRefType == null) this.fRefType = enumCellRefType.topbox;
    }

    var valueList = objTree.GetValueListForChild("cellcolrow", true);
    //	if (valueList == null)
    //		console.log("Bad bad");

    this.fCol = valueList[0];
    this.fRow = valueList[1];

    valueList = objTree.GetValueListForChild("alignment", false);
    if (valueList != null) {
      this.fAlignment = valueList[0];
      this.fVAlignment = MapVAlign(valueList[1]);

      var wrapT = valueList[2];
      if (wrapT == "true") wrapT = enumWrapTextMode.unlimited;
      else if (wrapT == "false") wrapT = enumWrapTextMode.nowrap;
      else wrapT = parseInt(wrapT);
      this.fWrapText = wrapT;

      var expandrow = objTree.GetValueForChild("expandrow", false);
      this.fExpandRow = expandrow == "true";

      valueList = objTree.GetValueListForChild("cellcolor", false);
      if (valueList[0] == "null") valueList[0] = "#000000";
      this.fCellFillColor = valueList[0];
      this.fCellFillMode = parseInt(valueList[1]);

      this.fCellFillColor2 = objTree.GetValueForChild("cellcolor2", false);
      if (this.fCellFillColor2 == null) this.fCellFillColor2 = "#FFFFFF";

      valueList = objTree.GetValueListForChild("celldisplaycontent", true);
      this.fFieldDisplayMode = valueList[0];
      this.fCellContentType = valueList[1];
      this.fCellObjectSubtype = objTree.GetValueForChild("cellsubtype", true);

      valueList = objTree.GetValueListForChild("picframe", true);
      if (valueList) {
        this.fPictureFrameWidth = valueList[0];
        this.fPictureFrameHeight = valueList[1];
      }

      var pMask = objTree.GetValueForChild("picmask", true);
      if (pMask == null) pMask = enumPicMask.nomask;
      this.fPicMask = pMask;
    } else {
      this.fAlignment = Globals._priorCellFormat.fAlignment;
      this.fVAlignment = Globals._priorCellFormat.fVAlignment;
      this.fExpandRow = Globals._priorCellFormat.fExpandRow;
      this.fWrapText = Globals._priorCellFormat.fWrapText;
      this.fCellFillColor = Globals._priorCellFormat.fCellFillColor;
      this.fCellFillColor2 = Globals._priorCellFormat.fCellFillColor2;

      this.fCellFillMode = Globals._priorCellFormat.fCellFillMode;
      this.fFieldDisplayMode = Globals._priorCellFormat.fFieldDisplayMode;
      this.fCellContentType = Globals._priorCellFormat.fCellContentType;
      this.fCellObjectSubtype = Globals._priorCellFormat.fCellObjectSubtype;

      this.fPictureFrameWidth = Globals._priorCellFormat.fPictureFrameWidth;
      this.fPictureFrameHeight = Globals._priorCellFormat.fPictureFrameHeight;
      this.fPicMask = Globals._priorCellFormat.fPicMask;
    }

    var freeText = objTree.GetValueForChild("freeText", false);
    if (freeText != null) this.fFreeText = freeText;

    var autoTextType = objTree.GetValueForChild("autoText", true);
    this.fAutoTextType = enumAutoTextType.none;
    if (autoTextType != null) this.fAutoTextType = autoTextType;

    valueList = objTree.GetValueListForChild("picture", false);
    if (valueList != null) {
      this.fSPictureDirectory = valueList[0];
      this.fSPictureFile = valueList[1];
      this.fSPictureWidth = parseInt(valueList[2]);
      this.fSPictureHeight = parseInt(valueList[3]);
    }

    var scaleMethod = objTree.GetValueForChild("pscale", true);
    this.fScalingMethod = enumScalingMethod.lockaspect;
    if (scaleMethod != null) this.fScalingMethod = scaleMethod;

    valueList = objTree.GetValueListForChild("locationrect", true);
    this.fLocationX = valueList[0];
    this.fLocationY = valueList[1];
    this.fCellWidth = valueList[2];
    this.fCellHeight = valueList[3];

    valueList = objTree.GetValueListForChild("merge", true);
    if (valueList != null) {
      this.fMergeX = valueList[0];
      this.fMergeY = valueList[1];
    }

    var hf = objTree.GetValueForChild("hide", false);
    if (hf != null) hf = StringToBool(hf);
    else hf = false;

    this.fHidden = hf;

    Globals._priorCellFormat = this;
  }

  CompareCells(boxCell, exactMatch, matchWidth, includeFreeText, isBoxStyle) {
    if (boxCell == null) return "BoxCell";

    // Common Properties
    if (exactMatch) {
      if (this.fAlignment != boxCell.fAlignment) return "Alignment";

      if (this.fVAlignment != boxCell.fVAlignment) return "VAlignment";

      if (this.fExpandRow != boxCell.fExpandRow) return "ExpandRow";
    }

    if (this.fCellFillMode != boxCell.fCellFillMode) return "CellFillMode";

    if (this.fCellFillMode != enumFillMode.noFill) {
      if (this.fCellFillColor != boxCell.fCellFillColor) return "CellFillColor";

      if (this.fCellFillColor2 != boxCell.fCellFillColor2) return "CellFillColor2";
    }

    if (this.fCellContentType != boxCell.fCellContentType) return "ContentType";

    if (matchWidth && this.fCellWidth != boxCell.fCellWidth) return "CellWidth";

    if (this.fField != boxCell.fField) return "Field";

    if (this.fRefType != boxCell.fRefType) return "RefType";

    if (this.fMergeX != boxCell.fMergeX) return "MergeX";

    if (this.fMergeY != boxCell.fMergeY) return "MergeY";

    if (this.fHidden != boxCell.fHidden) return "Hidden";

    var isPicture = this.IsPicture();
    if (isPicture || isBoxStyle) {
      if (exactMatch) {
        if (this.fPictureFrameWidth != boxCell.fPictureFrameWidth) return "picframewidth";

        if (this.fPictureFrameHeight != boxCell.fPictureFrameHeight) return "picframeheight";

        if (this.fPicMask != boxCell.fPicMask) return "picmask";
      }
    }

    if (!isPicture) {
      if (exactMatch) {
        if (this.fWrapText != boxCell.fWrapText) return "WrapText";
      }

      if (this.fFieldDisplayMode != boxCell.fFieldDisplayMode) return "FieldDisplayMode";
    }

    if (includeFreeText) {
      if (this.fFreeText != boxCell.fFreeText) return "FreeText";
    }

    return "Match";
  }

  OutputChildElements(stream) {
    var match = this.fTextFormat.Compare(Globals._priorTextFormat);
    if (match == false) this.fTextFormat.OutputToXML(stream);
    Globals._priorTextFormat = this.fTextFormat;

    /*
	var n = this.fBorderSegmentList.length;
	var priorSeg = null;
	for (var i=0; i<n; i++)
	{
		var borderSeg = this.fBorderSegmentList[i];
		var	match = borderSeg.Compare(gPriorBorderSegment);
		if (match == false)
			borderSeg.OutputToXML(stream);
		gPriorBorderSegment = borderSeg;
	}
	*/
  }

  GetBorderSegmentPlacement(borderSegList, index) {
    var l = borderSegList.length;
    if (index >= l) return -1;

    var borderSegInfo = borderSegList[index]; // objTree.GetIndexChildOfType("bordersegment", index);

    var valueList = borderSegInfo.GetValueListForChild("bs_properties", true);
    var curSegIndex = valueList[2];

    return curSegIndex;
  }

  LoadChildElements(objTree) {
    this.fTextFormat = new QTextFormat();
    this.fTextFormat.InitTextFormat();
    var textInfo = objTree.GetChildByName("textformat");
    this.fTextFormat.LoadFromXML(textInfo);
  }

  ReplaceFormat(replaceFrom, replaceContents) {
    this.fAlignment = replaceFrom.fAlignment;
    this.fVAlignment = replaceFrom.fVAlignment;
    this.fExpandRow = replaceFrom.fExpandRow;
    this.fWrapText = replaceFrom.fWrapText;
    this.fCellFillColor = replaceFrom.fCellFillColor;
    this.fCellFillColor2 = replaceFrom.fCellFillColor2;

    this.fCellFillMode = replaceFrom.fCellFillMode;

    this.fPictureFrameWidth = replaceFrom.fPictureFrameWidth;
    this.fPictureFrameHeight = replaceFrom.fPictureFrameHeight;
    this.fPicMask = replaceFrom.fPicMask;

    if (replaceContents) {
      var replaceField = replaceFrom.fField;
      this.SetField(replaceField);
      this.fCellContentType = replaceFrom.fCellContentType;
      this.fFieldDisplayMode = replaceFrom.fFieldDisplayMode;
      // lets save our free text changes
      if (this.fCellContentType == enumCellContentType.FreeText) {
        this.fFreeText = replaceFrom.fFreeText;
      }
    }

    this.fTextFormat = replaceFrom.fTextFormat.Clone();

    this.fCellHeight = replaceFrom.fCellHeight;
    this.fCellWidth = replaceFrom.fCellWidth;

    this.fHidden = replaceFrom.fHidden;
    /*
	if (this.fBorderSegmentList)
	{
		var n = this.fBorderSegmentList.length;
		for (var i=0; i<n; i++)
		{
			var dst = this.fBorderSegmentList[i];
			var src = replaceFrom.fBorderSegmentList[i];
			dst.ReplaceFormat(src);
		}
	}
	*/
  }

  // Mar29
  CompareProperties(srcCell, exactMatch, matchWidth, includeFreeText) {
    var result = this.CompareCells(srcCell, exactMatch, matchWidth, includeFreeText, false);
    if (result != "Match") return false;

    if (!this.IsPicture()) result = this.fTextFormat.Compare(srcCell.fTextFormat);
    if (result == false) return false;

    /*
	if (this.fBorderSegmentList)
	{
		var n = this.fBorderSegmentList.length;
		for (var i=0; i<n; i++)
		{
			var cur = this.fBorderSegmentList[i];
			var src = srcCell.fBorderSegmentList[i];
			result = cur.Compare(src);
			if (result == false)
				return false;
		}
	}
	*/

    return true;
  }

  GetFieldDisplayInfo(fieldDef, dataObj) {
    var f = new QFieldDisplayInfo();

    f.containsField = fieldDef != null;

    if (f.containsField) {
      f.displayName = fieldDef.GetFieldLabel();
      if (f.displayName == null || f.displayName.length == 0)
        f.displayName = fieldDef.GetFieldDisplayName();
      if (dataObj == null) f.fieldValue = f.displayName;
      else {
        if (dataObj.IsPositionObj() && fieldDef.GetFieldClassName() === enumObjClassNames.box) {
          dataObj = dataObj.GetHolderList()?.[0] ?? null;
        }
        f.fieldValue = dataObj != null ? dataObj.GetFieldValue(fieldDef) : "";
        f.breakChars = EscRegExpression(fieldDef.GetBreakChars());
      }

      if (f.fieldValue == null) f.fieldValue = "";

      f.fieldValue = FormatFieldValue(f.fieldValue, fieldDef, this);
    }

    return f;
  }

  GetFreeRefText(resolveRef) {
    var theContent = this.GetFreeText();

    if (resolveRef && this.IsRefText()) {
      var pLayout = this.fParentLayout;
      var theDoc = pLayout.GetDocRef();
      var dataObj = pLayout.GetDBObj();

      if (theDoc != null) theContent = theDoc.ResolveReference(theContent, dataObj);
    }

    return theContent;
  }

  // FieldName cannot have spaces. DisplayName can contain spaces
  PGetDisplayContent(displayName, fieldValue, containsField) {
    //var align = this.GetAlignment();
    var theContent;

    var fieldContent;
    if (containsField) {
      var displayMode = this.GetFieldDisplayMode();
      var dataVal = null;
      if (displayMode != enumFieldDisplayMode.LabelOnly) {
        dataVal = fieldValue; // dataObj.GetFieldValue(fieldDef);
        if (dataVal == null) dataVal = "";
      }

      switch (displayMode) {
        case enumFieldDisplayMode.FieldOnly:
          theContent = dataVal;
          break;
        case enumFieldDisplayMode.LabelOnly:
          theContent = displayName + ":";
          break;
        case enumFieldDisplayMode.LabelAndField:
          theContent = displayName + ": " + dataVal;
          break;
      }
    } else {
      if (this.IsFreeText()) theContent = this.GetFreeRefText(true);
      else if (this.IsAutoText()) return this.GetAutoText();
      else if (this.IsTableValue()) {
        theContent = this.GetTableValue();
      } else if (this.IsTableSum()) {
        theContent = this.CalculateTableSum();
      } else if (this.IsTablePercent()) {
        theContent = this.CalculateTablePercentage() + "%";
      } else theContent = "";
    }

    return theContent;
  }

  GetAccountName() {
    var theDoc = this.fParentLayout.GetDocRef();
    return theDoc.GetAccountName();
  }

  GetAutoText() {
    var autoTextType = this.GetAutoTextType();
    var theDoc = this.fParentLayout.GetDocRef();
    return theDoc.GetAutoText(autoTextType);
  }

  GetPicSourceInfo() {
    var picDesc = new QPicDesc();
    var dataObj = this.fParentLayout.GetDBObj();
    var pictureType = this.GetPictureType();
    switch (pictureType) {
      case enumPictureType.staticPicture:
        if (this.fSPictureFile) {
          picDesc.fDirectory = this.fSPictureDirectory;
          picDesc.fFileName = this.fSPictureFile;
          picDesc.fIsMaster = !dataObj;
        }
        break;
      case enumPictureType.fieldPicture:
        picDesc = GetPicSource(dataObj, this.fField);
        break;
      case enumPictureType.iconPicture:
        picDesc.fDirectory = "static/images";
        picDesc.fFileName = enumImageNameIndex[this.GetIconIndex()];
        break;
    }
    return picDesc;
  }

  ReloadPic() {
    var theDoc = this.fParentLayout.GetDocRef();

    var pDesc = this.GetPicSourceInfo();
    var pDir = pDesc.fDirectory;
    var pFile = pDesc.fFileName;

    theDoc.RemovePicture(pDir, pFile);
    this.fDeferredPicLoad = true;
  }

  // 2.1.3
  LoadCellPicture(callBack) {
    var pictureType = this.GetPictureType();

    var pFile = kMissingPic;
    var pDir = "Photos";
    var staticImage = false;
    switch (pictureType) {
      case enumPictureType.staticPicture:
        if (this.fSPictureFile) {
          pFile = this.fSPictureFile;
          pDir = this.fSPictureDirectory;
          staticImage = true;
        }
        break;
      case enumPictureType.fieldPicture:
        var pDesc = this.GetPicSourceInfo();
        pDir = pDesc.fDirectory;
        pFile = pDesc.fFileName;
        break;
      case enumPictureType.iconPicture:
        const wsmgr = Globals._wsMgr;
        const imageMgr = wsmgr.GetImageMgr();
        return imageMgr.GetIndexImage(this.GetIconIndex());
    }

    var theDoc = this.fParentLayout.GetDocRef();
    var theImage = theDoc.FindPicture(pDir, pFile);
    if (theImage == null && callBack) {
      //if (!theDoc.fDeferLoadPics)
      //{
      var picLoading = theDoc.PictureLoading(pDir, pFile, callBack);
      if (!picLoading) theDoc.LoadPicture(pDir, pFile, callBack, null, null, staticImage);
      //}
      //else
      //	this.fDeferredPicLoad = true;
    }

    if (theImage) this.SetSPictureSize(theImage.width, theImage.height);

    return theImage;
  }

  GetEscBreakChars() {
    return this.fBreakChars;
  }

  IsRefBox() {
    var subType = this.fParentLayout.GetBoxSubType();
    var isRefBox = IsRefBox(subType); //(subType == enumBoxSubTypes.refBoxTable) || (subType == enumBoxSubTypes.refBoxLegend);
    return isRefBox;
  }

  GetTopBoxRef() {
    //TODO: this is similar but slightly different from the pic source code.
    var refType = this.GetCellRefType();
    var pLayout = this.fParentLayout;
    var fallbackBranchRoot = false;
    var subType = pLayout.GetBoxSubType();
    var theDoc = pLayout.GetDocRef();
    var topObj = null;

    if (subType == enumBoxSubTypes.refMRBox) {
      return pLayout.GetContainerDataObjs();
    }
    if (pLayout.IsLayoutCellRefType()) {
      refType = pLayout.GetCellRefType();
      if (refType == null) refType = enumCellRefType.topbox;
      fallbackBranchRoot = true;
    }
    if (refType == enumCellRefType.topbox) {
      if (theDoc == null) return null;
      if (theDoc.fDocMgr?.IsPlanChart()) {
        topObj = Globals._wsMgr.GetPlanMgr().GetTopObjRef();
      } else {
        topObj = theDoc.GetRootObj();
      }
    }
    if (refType != enumCellRefType.topbox || (topObj == null && fallbackBranchRoot)) {
      var scm = theDoc?.GetSubChartMgr();
      var sc = scm?.GetActiveSubChart();
      if (sc != null) topObj = sc.GetTopDBObj();
      else topObj = theDoc?.GetRootObj() ?? null;
    }

    return topObj;
  }

  GetDisplayContent() {
    var aField = this.GetField();
    var dataObj;

    if (this.IsRefBox() && aField != null) {
      var pLayout = this.fParentLayout;
      var subType = pLayout.GetBoxSubType();
      if (pLayout.GetBoxSubType() == enumBoxSubTypes.refMRBox) {
        var dataObjArr = this.GetTopBoxRef();
        var fieldValArr = [];
        var lastF = null;
        for (var aDataObjIdx in dataObjArr) {
          dataObj = dataObjArr[aDataObjIdx];
          lastF = this.GetFieldDisplayInfo(aField, dataObj);
          this.fBreakChars = lastF.breakChars;
          if (lastF.fieldValue !== "") fieldValArr.push(lastF.fieldValue);
        }
        if (!lastF) return "";
        // Deduplicate field values, combine them, then apply label/display formatting once
        // so "LabelAndField" cells produce e.g. "Country: USA & EMEA" not "Country: USA & Country: EMEA"
        fieldValArr = fieldValArr.filter(function (value, index, array) {
          return array.indexOf(value) === index;
        });
        return this.PGetDisplayContent(
          lastF.displayName,
          formatArray(fieldValArr),
          lastF.containsField
        );
      } else if (subType == enumBoxSubTypes.refChart) {
        this.BuildPieChartContent();
        return;
      } else dataObj = this.GetTopBoxRef();
    } else {
      dataObj = this.fParentLayout.GetDBObj();
      if (dataObj == null && aField != null) {
        dataObj = this.GetTopBoxRef();
      }
    }

    var f = this.GetFieldDisplayInfo(aField, dataObj);
    this.fBreakChars = f.breakChars;
    //this.fEscBreakChars = f.escbreakChars;

    var content = this.PGetDisplayContent(f.displayName, f.fieldValue, f.containsField);

    return content;
  }

  GenerateAggregatedPieContent() {
    var theLayout = this.GetLayout();
    var aggregatedField = theLayout.GetEnumeratedTableRef();
    //var dataObj = this.GetTopBoxRef();
    var theDoc = theLayout.GetDocRef();
    var dataObj = this.GetTopBoxRef();
    if (aggregatedField == null || dataObj == null)
      // aggregated field reference lost, or no top dbObj
      return;
    var aggregatedFieldValues = theLayout.GetEnumeratedTableValues(this);
    if (aggregatedFieldValues == null)
      // aggregated field values for top dbobj not loaded
      return;
    var breakdown;
    var field;
    // making the assumption that a pie chart is only useful w/ a breakdown on 1 header.
    if (aggregatedField["columns"].length === 1) {
      field = aggregatedField["columns"][0];
      breakdown = aggregatedField["columnAggregationResult"];
    }
    /*else if(aggregatedField['rows'].length === 1)
	{
		field = aggregatedField['rows'][0];
		breakdown = aggregatedField['columnAggregationResult'];
	}*/
    if (breakdown == null) return; // table config not compatible with pie charts
    aggregatedFieldValues = aggregatedFieldValues[0];
    var results = {};
    for (var i = 0; i < breakdown.length; i++) {
      var innerResult = breakdown[i]["_id"]; // mongo aggregation result
      var valueObj = innerResult[field]; // field : {value: idx}
      if (valueObj == null) continue;
      var aValue = Object.keys(valueObj)[0];
      var anIdx = valueObj[aValue];
      var sanitizedValue = sanitizeBlockedValue(aValue, aValue);
      results[sanitizedValue] = (results[sanitizedValue] || 0) + aggregatedFieldValues[anIdx];
    }
    this.BuildPieDisplayObj(results);
  }

  BuildPieChartContent() {
    var aField = this.GetField();
    var dataObj = this.GetTopBoxRef();
    if (aField == null || dataObj == null) return "";
    var topbox = this.GetTopBoxRef();
    var objectList = [];
    topbox.GetAllChildren(objectList);
    var objDB = dataObj.GetParentClass().GetObjDB();
    var rawResult = objDB.GetUniqueFieldCountsFromFieldDef(aField, objectList); // {'fieldA': 1, 'fieldB':7}
    // Sanitize blocked sentinel values so they display as "(hidden)" in legend/pie
    var fieldResult = {};
    for (var rawKey in rawResult) {
      var sanitizedKey = sanitizeBlockedValue(rawKey, rawKey);
      fieldResult[sanitizedKey] = (fieldResult[sanitizedKey] || 0) + rawResult[rawKey];
    }
    this.BuildPieDisplayObj(fieldResult);
  }

  BuildPieDisplayObj(fieldResult) {
    var normalizedFieldInfo = [];
    var otherThreshold = 3;
    var otherBucket = { value: "Other", percent: 0, color: kPickerColors[1] };
    var total = 0;
    var ColorIndex = 1;
    var ColorColumn = 1;

    var theLayout = this.GetLayout();
    if (theLayout.GetValueColorMap() == null) theLayout.fValueColorMap = {};
    var colorMap = theLayout.GetValueColorMap();

    for (var aKey in fieldResult) {
      total += fieldResult[aKey];
    }

    for (var aKey in fieldResult) {
      var count = fieldResult[aKey];
      var percent = (count / total) * 100;
      if (percent > otherThreshold) {
        if (colorMap[aKey] == null) colorMap[aKey] = kPickerColors[6 * ColorIndex + ColorColumn];
        ColorIndex += 1;
        if (ColorIndex > 5) {
          ColorIndex = 1;
          ColorColumn -= 1;
        }
        ColorIndex = ColorIndex < 5 ? ColorIndex + 1 : 1;
        normalizedFieldInfo.push({
          value: aKey,
          percent: percent,
          color: colorMap[aKey]
        });
      } else otherBucket["percent"] += percent;
    }
    if (otherBucket["percent"] > 0) normalizedFieldInfo.push(otherBucket);
    theLayout.SetValueColorMap(colorMap); // may be unnecessary. should already have an obj ref.
    this.fPieSections = normalizedFieldInfo;
  }

  GetLinkContent(hasLabel) {
    var aField = this.GetField();
    var dataObj;
    if (this.IsRefBox()) dataObj = this.GetTopBoxRef();
    else dataObj = this.fParentLayout.GetDBObj();

    var v = GetFieldLink(aField, dataObj, hasLabel);
    return v;
  }

  SetMeasuredHeight(
    measuredHeight // contentHeight
  ) {
    this.fMeasuredHeight = measuredHeight;
    //this.fContentHeight = contentHeight;
  }

  GetMeasuredHeight() {
    return this.fMeasuredHeight;
  }

  GetContentHeight() {
    return this.fContentHeight;
  }

  SkipGutterCell(theProperty) {
    // Skip gutter cells unless cellFillColor
    var gutterCell = this.IsGutterCell();
    if (!gutterCell || theProperty == enumUpdateProperty.cellFillColor) return false;
    return true;
  }

  UpdateBoxCellDesc(parameter, property, doOverride = true) {
    var needRecalc = false;
    if (doOverride && !this.fOverrides) {
      this.fOverrides = {};
    }
    switch (property) {
      //Text Format Changes
      case enumUpdateProperty.cellTextBold:
        doOverride ? this.SetOverrideTextBold(parameter) : this.SetTextBold(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.cellTextItalic:
        doOverride ? this.SetOverrideTextItalic(parameter) : this.SetTextItalic(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.cellTextUnderline:
        doOverride ? this.SetOverrideTextUnderline(parameter) : this.SetTextUnderline(parameter);
        break;
      case enumUpdateProperty.cellFontColor:
        doOverride
          ? this.SetOverrideFontColor(parameter.fSelectedColor)
          : this.SetFontColor(parameter.fSelectedColor);
        break;
      case enumUpdateProperty.fontName:
        doOverride ? this.SetOverrideFontName(parameter) : this.SetFontName(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.fontSize:
        doOverride ? this.SetOverrideFontSize(parameter) : this.SetFontSize(parameter);
        needRecalc = true;
        break;
      // Cell Format Changes
      case enumUpdateProperty.cellExpandRow:
        //Some of the below items may never need to be overrides
        doOverride ? this.SetOverrideExpandRow(parameter) : this.SetExpandRow(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.cellRefType:
        doOverride ? this.SetOverrideCellRefType(parameter) : this.SetCellRefType(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.fieldDisplayMode:
        doOverride
          ? this.SetOverrideFieldDisplayMode(parameter)
          : this.SetFieldDisplayMode(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.cellFillColor:
        if (doOverride) {
          this.SetOverrideCellFillColor(parameter.fSelectedColor);
          this.SetOverrideCellFillColor2(parameter.fSelectedColor2);
          this.SetOverrideCellFillMode(parameter.fFillMode);
        } else {
          this.SetCellFillColor(parameter.fSelectedColor);
          this.SetCellFillColor2(parameter.fSelectedColor2);
          this.SetCellFillMode(parameter.fFillMode);
        }
        needRecalc = true; // for masked pictures
        break;
      case enumUpdateProperty.cellTextAlign:
        doOverride ? this.SetOverrideAlignment(parameter) : this.SetAlignment(parameter);
        break;
      case enumUpdateProperty.cellWrapText:
        doOverride ? this.SetOverrideWrapText(parameter) : this.SetWrapText(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.picFrame:
        doOverride ? this.SetOverridePictureFrame(parameter) : this.SetPictureFrame(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.picMask:
        doOverride ? this.SetOverridePictureMask(parameter) : this.SetPictureMask(parameter);
        needRecalc = true;
        break;
      case enumUpdateProperty.cellTextVAlign:
        doOverride
          ? this.SetOverrideVAlignment(parameter, true)
          : this.SetVAlignment(parameter, true);
        break;
    }
    return needRecalc;
  }

  GetRowIndex() {
    return this.fRow;
  }

  GetColIndex() {
    return this.fCol;
  }

  ShiftCellColumn(shiftLeft) {
    if (shiftLeft) this.fCol--;
    else this.fCol++;
  }

  ShiftCellRow(shiftUp) {
    if (shiftUp) this.fRow--;
    else this.fRow++;
  }

  SetOverrideCellFillMode(fillMode) {
    this.Journal();
    this.fOverrides["fCellFillMode"] = fillMode;
  }

  GetCellFillMode() {
    return this.GetOverridesKey("fCellFillMode", this.fCellFillMode);
  }

  SetCellFillMode(fillMode) {
    this.fCellFillMode = fillMode;
  }

  SetOverrideCellFillColor(fillColor) {
    this.Journal();
    this.fOverrides["fCellFillColor"] = fillColor;
  }

  GetCellFillColor() {
    return this.GetOverridesKey("fCellFillColor", this.fCellFillColor);
  }

  SetCellFillColor(fillColor) {
    this.Journal();
    this.fCellFillColor = fillColor;
  }

  SetOverrideCellFillColor2(fillColor2) {
    this.Journal();
    this.fOverrides["fCellFillColor2"] = fillColor2;
  }

  GetCellFillColor2() {
    return this.GetOverridesKey("fCellFillColor2", this.fCellFillColor2);
  }

  SetCellFillColor2(fillColor) {
    //   this.Journal();
    this.fCellFillColor2 = fillColor;
  }

  // Calculated values
  GetLocationX() {
    return this.fLocationX;
  }

  GetLocationY() {
    return this.fLocationY;
  }

  SetLocation(xLoc, yLoc) {
    this.fLocationX = xLoc;
    this.fLocationY = yLoc;

    //	if (xLoc != Math.floor(xLoc))
    //	{
    //		console.log("Problemo");
    //	}
  }

  GetCellWidth() {
    return this.fCellWidth;
  }

  SetCellWidth(cellWidth) {
    this.fCellWidth = cellWidth;
  }

  GetCellHeight() {
    return this.fCellHeight;
  }

  CalcObjectHeight() {
    var height = 0;
    if (!this.f2DElements) return this.fCellHeight;
    for (var aRow in this.f2DElements) {
      var subRow = this.f2DElements[aRow][0];
      if (subRow) height += this.f2DElements[aRow][0].GetHeight();
    }
    return height;
  }

  SetCellHeight(cellHeight) {
    this.fCellHeight = cellHeight;
  }

  GetCellNumRows(limited) {
    if (limited) return this.fNumRowsInCell;
    else return this.fNumContentRows;
  }

  IsOccupied() {
    //Is there content in this cell that means it's not
    var field = this.GetFieldSaveName();
    var contentType = this.GetCellContentType();
    return field || contentType === enumCellContentType.FreeText;
  }

  SetCellNumRows(numRows, numRowsInContent) {
    this.fNumRowsInCell = numRows;
    this.fNumContentRows = numRowsInContent;
  }

  IsGutterCell() {
    return this.fGutterCell;
  }

  GetTextFormat() {
    return this.fTextFormat;
  }

  TEGetFontString() {
    var txtFormat = this.GetTextFormat();
    var fontString = txtFormat.BuildFontString();
    return fontString;
  }

  SetTextBold(setOn) {
    this.Journal();
    this.fTextFormat.SetTextBold(setOn);
  }

  SetOverrideTextBold(setOn) {
    this.Journal();
    this.fTextFormat.SetOverrideTextBold(setOn);
  }

  GetTextItalic() {
    return this.fTextFormat.GetTextItalic();
  }

  SetTextItalic(setOn) {
    this.Journal();
    this.fTextFormat.SetTextItalic(setOn);
  }

  SetOverrideTextItalic(setOn) {
    this.Journal();
    this.fTextFormat.SetOverrideTextItalic(setOn);
  }

  GetTextUnderline() {
    return this.fTextFormat.GetTextUnderline();
  }

  SetTextUnderline(setOn) {
    this.Journal();
    this.fTextFormat.SetTextUnderline(setOn);
  }

  SetOverrideTextUnderline(setOn) {
    this.Journal();
    this.fTextFormat.SetOverrideTextUnderline(setOn);
  }

  GetFontColor() {
    return this.fTextFormat.GetFontColor();
  }

  SetFontColor(fontColor) {
    this.Journal();
    this.fTextFormat.SetFontColor(fontColor);
  }

  SetOverrideFontColor(setOn) {
    this.Journal();
    this.fTextFormat.SetOverrideFontColor(setOn);
  }

  GetTextBold() {
    return this.fTextFormat.GetTextBold();
  }

  SetOverrideAlignment(alignment) {
    this.Journal();
    this.fOverrides["fAlignment"] = alignment;
  }

  GetAlignment() {
    return this.GetOverridesKey("fAlignment", this.fAlignment);
  }

  SetAlignment(textAlignment) {
    this.Journal();
    this.fAlignment = textAlignment;
  }

  GetVAlignment(fullVal) {
    var vAlign = this.GetOverridesKey("fVAlignment", this.fVAlignment);
    if (fullVal) {
      var alignMap = {
        m: "middle",
        t: "top",
        b: "bottom"
      };
      return alignMap[vAlign];
    } else return vAlign;
  }

  SetOverrideVAlignment(textVAlignment, mapIt) {
    this.Journal();
    var vAlign;
    if (mapIt) vAlign = MapVAlign(textVAlignment);
    else vAlign = textVAlignment;

    this.fOverrides["fVAlignment"] = vAlign;
  }

  SetVAlignment(textVAlignment, mapIt) {
    this.Journal();
    var vAlign;
    if (mapIt) vAlign = MapVAlign(textVAlignment);
    else vAlign = textVAlignment;

    this.fVAlignment = vAlign;
  }

  GetExpandRow() {
    return this.GetOverridesKey("fExpandRow", this.fExpandRow);
  }

  SetExpandRow(expandRow) {
    if (expandRow) this.fParentLayout.ClearExpandRow();

    this.fExpandRow = expandRow;
  }

  SetOverrideExpandRow(expandRow) {
    if (expandRow) this.fParentLayout.ClearExpandRow();

    this.fOverrides["fExpandRow"] = expandRow;
  }

  SetOverrideWrapText(wrapText) {
    this.Journal();
    this.fOverrides["fWrapText"] = wrapText;
  }

  GetWrapText() {
    return this.GetOverridesKey("fWrapText", this.fWrapText);
  }

  SetWrapText(wrapText) {
    this.Journal();
    this.fWrapText = wrapText;
  }

  SetMaxCellRows(maxCellRows) {
    this.fMaxCellRows = maxCellRows;
  }

  GetMaxCellRows() {
    return this.fMaxCellRows;
  }

  SetFontSize(fontSize) {
    this.Journal();
    this.fTextFormat.SetFontSize(fontSize);
  }

  SetOverrideFontSize(fontSize) {
    this.Journal();
    this.fTextFormat.SetOverrideFontSize(fontSize);
  }

  GetFontSize() {
    return this.fTextFormat.GetFontSize();
  }

  SetFontName(fontName) {
    this.Journal();
    this.fTextFormat.SetFontName(fontName);
  }

  SetOverrideFontName(fontName) {
    this.Journal();
    this.fTextFormat.SetOverrideFontName(fontName);
  }

  GetFontName() {
    return this.fTextFormat.GetFontName();
  }

  // Used for loading from persistent storage
  SetFieldInfo(fieldName, fieldID, className) {
    this.fFieldName = fieldName;
    this.fFieldID = fieldID;
    this.fFieldClassName = className;
  }

  GetFieldSaveName() {
    return this.fFieldName;
  }

  GetFieldSaveID() {
    return this.fFieldID;
  }

  GetFieldDisplayName() {
    var f = this.fFieldName;
    if (f != null) {
      f = f.replaceAll("^", " ");
      //f.replace(/^/g," ");
    } else f = "";
    return f;
  }

  GetFieldSaveClassName() {
    return this.fFieldClassName;
  }

  SetField(aField) {
    var contentType = enumCellContentType.Blank;
    this.fField = aField;

    if (aField != null) {
      this.SetFieldInfo(aField.GetFieldName(), aField.GetFieldID(), aField.GetFieldClassName());
      if (aField.GetFieldType() === enumFieldType.object) {
        //Here
        contentType = enumCellContentType.object;
        var subtype = aField.GetFieldSubtype();
        this.SetCellContentType(contentType);
        this.SetCellObjectSubtype(subtype);
        return;
      } else contentType = enumCellContentType.Field;
    } else this.SetFieldInfo(null, null, null);

    if (this.GetCellContentType() != enumCellContentType.pieChart)
      this.SetCellContentType(contentType);
  }

  SetCellRefType(refType) {
    this.fRefType = refType;
  }

  GetCellRefType() {
    return this.GetOverridesKey("fRefType", this.fRefType);
  }

  SetOverrideCellRefType(refType) {
    this.fOverrides["fRefType"] = refType;
  }

  RemoveFieldReferences(fieldRefList, updateRef = false) {
    var curField = this.GetField();
    if (curField == null) return false;

    var curDoc = Globals._wsMgr.GetDoc();
    var objDB = curDoc.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");

    var n = fieldRefList.length;
    for (var i = 0; i < n; i++) {
      var newFieldRef = null;
      var aFieldRef = fieldRefList[i];
      var matchingUpdateID = updateRef && curField.GetFieldID() == aFieldRef.GetFieldID();
      if (curField == aFieldRef || matchingUpdateID) {
        if (matchingUpdateID) {
          var fieldRefID = curField.GetFieldID();
          // Prefer the field's own parent class (e.g. Position class fields survive sync correctly)
          var parentClass = curField.GetParentClass();
          var activeFieldDefRef =
            (parentClass ? parentClass.GetFieldDefByID(fieldRefID) : null) ??
            boxClass.GetFieldDefByID(fieldRefID);
          // if field is found that matches old reference, update it, otherwise remove reference
          if (activeFieldDefRef != null) newFieldRef = activeFieldDefRef;
        }
        this.SetField(newFieldRef);
        return true;
      }
    }
    // if we get here and the field ref is no longer in the doc field defs - we will remove the reference when we are updating the existing cells
    if (updateRef) this.SetField(null);
    return false;
  }

  GetField() {
    return this.fField;
  }

  SetOverrideFieldDisplayMode(displayMode) {
    this.Journal();
    this.fOverrides["fFieldDisplayMode"] = displayMode;
  }

  SetFieldDisplayMode(displayMode) {
    this.Journal();
    this.fFieldDisplayMode = displayMode;
  }

  GetFieldDisplayMode() {
    return this.GetOverridesKey("fFieldDisplayMode", this.fFieldDisplayMode);
  }

  SetCellContentType(contentType) {
    this.fCellContentType = contentType;

    var freeText = null;
    if (this.IsFreeText()) freeText = "";
    this.SetFreeText(freeText);

    var pframeW = null;
    var pframeH = null;
    if (this.IsPicture()) {
      pframeW = this.GetPictureFrameWidth(false);
      pframeH = this.GetPictureFrameHeight(false);
      if (pframeW == null) pframeW = kDefPicFrameW;
      if (pframeH == null) pframeH = kDefPicFrameH;
    }

    this.SetPictureFrameWidth(pframeW);
    this.SetPictureFrameHeight(pframeH);
  }

  GetCellContentType() {
    return this.fCellContentType;
  }

  GetCellObjectSubtype() {
    return this.fCellObjectSubtype;
  }

  SetCellObjectSubtype(subtype) {
    this.fCellObjectSubtype = subtype;
  }

  SetOverrideFreeText(freeText) {
    if (freeText === null) {
      return;
    }
    this.Journal();
    this.fOverrides["fFreeText"] = freeText;
  }

  SetFreeText(freeText) {
    this.Journal();
    this.fFreeText = freeText;
  }

  GetFreeText() {
    return this.GetOverridesKey("fFreeText", this.fFreeText);
  }

  IsRefText() {
    var f = this.GetFreeText();
    if (f && f.length > 3) {
      if (f[0] == "[" && f[1] == "$") return true;
    }

    return false;
  }

  IsFreeText() {
    var contentType = this.GetCellContentType();
    if (contentType == enumCellContentType.FreeText) return true;
    else return false;
  }

  GetPictureType() {
    var contentType = this.GetCellContentType();
    if (contentType == enumCellContentType.icon) return enumPictureType.iconPicture;
    if (contentType == enumCellContentType.Picture) return enumPictureType.staticPicture;
    else if (contentType == enumCellContentType.Field) {
      var field = this.GetField();
      if (field) {
        var fieldType = field.GetFieldType();
        if (fieldType == enumFieldType.image) return enumPictureType.fieldPicture;
      }
    }

    return enumPictureType.notPicture;
  }

  IsPicture() {
    var pictureType = this.GetPictureType();
    if (pictureType != enumPictureType.notPicture) return true;

    return false;
  }

  IsObject() {
    var contentType = this.GetCellContentType();
    return contentType === enumCellContentType.object;
  }

  IsChart() {
    if (this.IsRefBox()) {
      var contentType = this.GetCellContentType();
      return contentType == enumCellContentType.pieChart;
    }

    return false;
  }

  // Static Pictures - reference to picture from box layout
  SetSPictureDirectory(pictureDirectory) {
    this.fSPictureDirectory = pictureDirectory;
  }

  GetSPictureDirectory() {
    return this.fSPictureDirectory;
  }

  SetSPictureFile(pictureFile) {
    this.fSPictureFile = pictureFile;
  }

  GetSPictureFile() {
    return this.fSPictureFile;
  }

  SetSPictureSize(width, height) {
    this.Journal();
    this.fSPictureWidth = width;
    this.fSPictureHeight = height;
  }

  GetSPictureWidth() {
    return this.fSPictureWidth;
  }

  GetSPictureHeight() {
    return this.fSPictureHeight;
  }

  SetIconIndex(idx) {
    this.fIconIndex = idx;
  }

  GetIconIndex() {
    return this.fIconIndex;
  }

  GetScalingMethod() {
    return this.fScalingMethod;
  }

  SetScalingMethod(scalingMethod) {
    this.Journal();
    this.fScalingMethod = scalingMethod;
  }

  GetSPictureScaleW() {
    var pw = this.GetSPictureWidth();
    var cw = this.GetCellWidth();

    var scaleF = cw / pw;
    scaleF = Math.round(LDecimalPlaces(scaleF, 2) * 100);
    return parseInt(scaleF);
  }

  GetSPictureScaleH() {
    var ph = this.GetSPictureHeight();
    var ch = this.GetCellHeight();

    var scaleF = ch / ph;
    scaleF = Math.round(LDecimalPlaces(scaleF, 2) * 100);
    return parseInt(scaleF);
  }

  ScaleSPicture(scaleW, scaleH) {
    this.Journal();
    scaleW = scaleW / 100;
    scaleH = scaleH / 100;

    var pw = this.GetSPictureWidth();
    var ph = this.GetSPictureHeight();

    var cw = Math.round(pw * scaleW);
    var ch = Math.round(ph * scaleH);

    this.SetCellWidth(cw);
    this.SetCellHeight(ch);

    var p = new QPoint();
    p.fX = cw;
    p.fY = ch;

    return p;
  }

  IsHyperLink() {
    var theField = this.GetField();
    if (theField == null) return false;

    var hType = theField.GetHyperlinkType();
    return hType == enumHyperLinkType.hyperlink;
  }

  GetLinkType() {
    var theField = this.GetField();
    if (theField == null) return false;

    var hType = theField.GetHyperlinkType();
    switch (hType) {
      case enumHyperLinkType.email:
        return "mailto:";
      case enumHyperLinkType.skype:
        return "sip:";
      case enumHyperLinkType.phone:
        return "tel:";
      case enumHyperLinkType.hyperlink:
        return "https://";
      case enumHyperLinkType.file:
        //??? Will this work as a URI?
        return false;
    }
    return false;
  }

  GetRightClickActionList() {
    //	var isPicture = this.IsPicture();
    var theField = this.GetField();
    if (theField == null) return null;

    var dataObj = null;
    if (this.fParentLayout) dataObj = this.fParentLayout.GetDBObj();
    var cellActions = theField.GetRightClickActionList(dataObj);

    return cellActions;
  }

  // Cell Pictures - based off of field
  SetCellPictureInfo(directory, fileName) {
    var s = directory + ":" + fileName;
    var theField = this.fField;
    var dataObj = this.fParentLayout.GetDBObj();
    dataObj.SetFieldValue(theField, s);
  }

  GetPictureFrameWidth(addPadding) {
    var a = this.fPictureFrameWidth;
    if (addPadding) a += 4;
    return a;
  }

  SetPictureFrameWidth(frameWidth) {
    this.fPictureFrameWidth = frameWidth;
  }

  GetPictureFrameHeight(addPadding) {
    var a = this.fPictureFrameHeight;
    if (addPadding) a += 4;
    return a;
  }

  SetPictureFrameHeight(frameHeight) {
    this.fPictureFrameHeight = frameHeight;
  }

  SetPictureFrame(frame) {
    this.fPictureFrameWidth = frame.fX;
    this.fPictureFrameHeight = frame.fY;
  }

  SetOverridePictureFrame(frame) {
    this.fOverrides["fPictureFrameWidth"] = frame.fX;
    this.fOverrides["fPictureFrameHeight"] = frame.fY;
  }

  GetPictureFrame() {
    var frame = new QPoint();

    frame.fX = this.GetOverridesKey("fPictureFrameWidth", this.fPictureFrameWidth);
    frame.fY = this.GetOverridesKey("fPictureFrameHeight", this.fPictureFrameHeight);

    return frame;
  }

  GetNativePictureFrame() {
    var frame = new QPoint();

    frame.fX = this.fPictureFrameWidth;
    frame.fY = this.fPictureFrameHeight;

    return frame;
  }

  GetOverridePictureFrame() {
    var frame = new QPoint();

    frame.fX = this.fOverrides["fPictureFrameWidth"];
    frame.fY = this.fOverrides["fPictureFrameHeight"];

    if (frame.fX == null || frame.fY == null) {
      return null;
    }

    return frame;
  }

  SetPictureMask(picMask) {
    this.fPicMask = picMask;
  }

  SetOverridePictureMask(picMask) {
    this.fOverrides["fPicMask"] = picMask;
  }

  GetPictureMask() {
    return this.GetOverridesKey("fPicMask", this.fPicMask);
  }

  GetWidthPositionX(buffer) {
    if (buffer == null) buffer = 0;
    return this.GetLocationX() + this.GetCellWidth() + buffer;
  }

  // Auto text elements
  SetAutoTextType(autoTextType) {
    this.fAutoTextType = autoTextType;
  }

  GetAutoTextType() {
    return this.fAutoTextType;
  }

  IsAutoText() {
    var contentType = this.GetCellContentType();
    if (contentType == enumCellContentType.AutoText) return true;
    else return false;
  }

  IsTableValue() {
    var contentType = this.GetCellContentType();
    return contentType === enumCellContentType.tableValue;
  }

  // sum col || % col sum
  IsTableSum() {
    var contentType = this.GetCellContentType();
    return contentType === enumCellContentType.tableSum;
  }

  IsTablePercent() {
    var contentType = this.GetCellContentType();
    return contentType === enumCellContentType.tablePercent;
  }

  GetTableValue() {
    var theLayout = this.GetLayout();
    var tableValue = theLayout.GetTableValueByIndices(this, this.GetColIndex(), this.GetRowIndex());
    if (tableValue != null) return tableValue;
    return 0;
  }

  CalculateTableSum() {
    var colIdx = this.GetColIndex();
    var rowIdx = this.GetRowIndex();
    var calcResult = this.GetColSum(rowIdx, colIdx);

    return calcResult;
  }

  GetColSum(rowIdx, colIdx) {
    var theLayout = this.GetLayout();
    var calcResult = 0;

    for (var i = rowIdx - 1; i >= theLayout.GetValRowStartIdx(); i--) {
      var tableValue = theLayout.GetTableValueByIndices(this, colIdx, i);
      if (tableValue != null) calcResult += tableValue;
    }
    return calcResult;
  }

  CalculateTablePercentage() {
    var theLayout = this.GetLayout();
    var colIdx = this.GetColIndex();
    var rowIdx = this.GetRowIndex();

    var thisColResult = this.GetColSum(rowIdx, colIdx);
    var calcResult = thisColResult;

    // iterate through columns here... rowIdx will not change.
    for (var i = theLayout.GetValColStartIdx(); i <= theLayout.fNumCols; i++) {
      if (i === colIdx) continue;
      calcResult += this.GetColSum(rowIdx, i);
    }
    if (thisColResult <= 0 || calcResult <= 0)
      // div by 0
      return 0;
    return ((thisColResult / calcResult) * 100).toFixed(2);
  }

  IsCellStatic() {
    var isStatic = true;
    var fieldDef = this.GetField();
    if (fieldDef == null) {
      // autotext is static
      if (this.IsFreeText()) return false;
      return isStatic;
    }

    if (this.IsRefBox()) return true;
    if (this.IsObject()) return true;

    var displayMode = this.GetFieldDisplayMode();
    switch (displayMode) {
      case enumFieldDisplayMode.FieldOnly:
      case enumFieldDisplayMode.LabelAndField:
        isStatic = false;
        break;
    }

    return isStatic;
  }

  GetARTCellHeight() {
    var dbObj = this.fParentLayout.GetDBObj();
    if (this.fParentLayout.IsBoxStyle()) return this.fCellHeight;
    var artList = dbObj.SmartGetFieldValue("Also Reports To");
    if (artList == null || artList.length === 0) return this.fCellHeight;
    var addedIDs = [];
    var artObjs = [];
    var curDoc = Globals._wsMgr.GetDoc();
    var recordIDKey =
      curDoc.GetHierarchyType() === enumHierarchyTypes.positions ? "PositionID" : "PersonID"; // todo: replace false w/ positions check
    var recordSupervisorKey =
      curDoc.GetHierarchyType() === enumHierarchyTypes.positions
        ? "Parent PositionID"
        : "SupervisorID"; // todo: replace false w/ positions check
    var mySupervisor = this.fParentLayout.GetDBObj().SmartGetFieldValue(recordSupervisorKey);
    for (var i in artList) {
      var anOption = artList[i]; // backend obj
      if (anOption[recordIDKey] !== mySupervisor && addedIDs.indexOf(anOption[recordIDKey]) < 0) {
        if (addedIDs.length < 1) {
          //enumFieldDisplayMode.LabelAndField
          if (this.GetFieldDisplayMode() === enumFieldDisplayMode.LabelAndField) {
            var newBoxCellObj = new QBoxCellObj();
            if (false)
              // todo: replace false w/ positions check
              var label = {
                Title: this.GetField().GetFieldLabel() + ":",
                PositionID: ""
              };
            else
              label = {
                Name: this.GetField().GetFieldLabel() + ":",
                PersonID: ""
              };
            newBoxCellObj.InitBoxCellObj(this, this.GetField(), label, this.GetCellObjectSubtype());
            newBoxCellObj.fIsLabel = true;
            artObjs.push(newBoxCellObj);
          }
        }
        var newBoxCellObj = new QBoxCellObj();
        newBoxCellObj.InitBoxCellObj(this, this.fFieldDef, anOption, this.GetCellObjectSubtype());
        addedIDs.push(anOption[recordIDKey]);
        artObjs.push(newBoxCellObj);
      }
    }
    var elementStructure = this.PositionElements(artObjs);
    var height = 4; // allow for a slight buffer from top of cell
    if (elementStructure.length < 1) return this.fCellHeight;
    for (var aRow in elementStructure) {
      var subRow = elementStructure[aRow][0];
      if (subRow) height += elementStructure[aRow][0].GetHeight();
    }
    return height;
  }

  PositionElements(artObjects) {
    if (!artObjects || artObjects.length < 1) return [];
    var eleStructure = [[]];
    var buffer = 0;
    var elementList = artObjects;
    var rowHeight = elementList[0].GetHeight() + 1;
    var maxRows = Math.ceil(this.GetCellHeight() / rowHeight);
    var yPos = this.GetLocationY() + 1;
    var startingX = this.GetLocationX() + 2;
    var curX = startingX;
    var rightBorder = this.GetWidthPositionX();
    var index = 0;
    for (var eleIdx in elementList) {
      var curElement = elementList[eleIdx];
      curElement.fAltElementList = artObjects;
      if (curX + buffer + curElement.GetWidth() + curElement.GetSeparatorWidth() > rightBorder) {
        if (index === maxRows) break;
        // do not drop to next available row unless another ele is present in curRow
        if (eleStructure[index].length > 0) {
          index += 1;
          eleStructure[index] = [];
          curX = startingX;
          yPos += rowHeight;
        }
      }
      eleStructure[index].push(curElement);
      curX += curElement.GetWidth() + curElement.GetSeparatorWidth() + buffer;
    }
    return eleStructure;
  }

  GetARTStringValue(artList) {
    var myObj = this.fParentLayout.GetDBObj();
    var mySupervisorID = myObj.GetObjectSupervisorID();
    var artStr = "";
    var filteredList = artList.filter(function (anObj) {
      return anObj["PersonID"] !== mySupervisorID;
    });
    var n = filteredList.length;
    for (var i = 0; i < n; i++) {
      var anARTObj = filteredList[i];
      artStr += anARTObj["Name"];
      if (i === n - 1 || this.fIsLabel) artStr += "";
      else if (n === 2) artStr += " & ";
      else if (i < n - 2) artStr += ", ";
      else artStr += ", & ";
    }
    return artStr;
  }

  //=================================================================================================
  // Cells under pictures are hidden
  IsHidden() {
    return this.fHidden;
  }

  SetHidden(hidden) {
    this.fHidden = hidden;
  }

  //========================================================================
  // Merged Cells
  IsMergedCell() {
    var isMerged = this.fMergeX != 0 || this.fMergeY != 0;
    return isMerged;
  }

  GetMergeX() {
    return this.fMergeX;
  }

  GetMergeY() {
    return this.fMergeY;
  }

  SetMergeX(mergeX) {
    this.fMergeX = mergeX;
  }

  SetMergeY(mergeY) {
    this.fMergeY = mergeY;
  }

  GetLayout() {
    return this.fParentLayout;
  }
}
